webpackJsonp([58411574672382],{

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Card = __webpack_require__(66);
	
	var _GitHub = __webpack_require__(103);
	
	var _GitHub2 = _interopRequireDefault(_GitHub);
	
	var _Twitter = __webpack_require__(105);
	
	var _Twitter2 = _interopRequireDefault(_Twitter);
	
	var _Instagram = __webpack_require__(104);
	
	var _Instagram2 = _interopRequireDefault(_Instagram);
	
	var _SlideUp = __webpack_require__(5);
	
	var _SlideUp2 = _interopRequireDefault(_SlideUp);
	
	var _Browser = __webpack_require__(6);
	
	var _Browser2 = _interopRequireDefault(_Browser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint max-len: 0 */
	
	var MyLinkCard = /*#__PURE__*/(0, _reactEmotion2.default)(_Card.LinkCard, {
	  target: 'es44l6p0'
	})();
	
	//import Discord from '../icons/logo/Discord';
	//import Behance from '../icons/logo/Behance';
	//import YouTube from '../icons/logo/YouTube';
	
	//import LinkedIn from '../icons/logo/LinkedIn';
	
	var Base = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'es44l6p1'
	})('font-size:1.5rem;z-index:8;top:0px;position:relative;padding-top:1.75rem;padding-bottom:2.75rem;padding-left:2rem;padding-right:2rem;max-width:77rem;margin-left:auto;margin-right:auto;display:grid;grid-template-columns:repeat(3,1fr);grid-column-gap:2rem;grid-row-gap:2rem;background-color:rgba();@media (max-width:', function (props) {
	  return props.theme.breakpoints.m;
	}, '){grid-template-columns:1fr;}');
	
	var SlideUp00 = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'es44l6p2'
	})();
	
	var ContactCards = function ContactCards() {
	  if ((0, _Browser2.default)() === 'chrome') {
	    SlideUp00 = _SlideUp2.default;
	  }
	  return _react2.default.createElement(
	    SlideUp00,
	    { delay: 450, fromX: '-60px', fromY: '60px' },
	    _react2.default.createElement(
	      Base,
	      null,
	      _react2.default.createElement(
	        MyLinkCard,
	        { link: 'https://www.twitter.com/SondroTW', twitter: true, skewYanim: true },
	        _react2.default.createElement(_Twitter2.default, null),
	        'Twitter'
	      ),
	      _react2.default.createElement(
	        MyLinkCard,
	        { link: 'https://www.github.com/Sondro', github: true, skewYanim: true },
	        _react2.default.createElement(_GitHub2.default, null),
	        'GitHub'
	      ),
	      _react2.default.createElement(
	        MyLinkCard,
	        { link: 'https://www.instagram.com/SondroIG', instagram: true, skewYanim: true },
	        _react2.default.createElement(_Instagram2.default, null),
	        'Instagram'
	      )
	    )
	  );
	};
	
	/*
	const ContactCards = () => {
	  if (Browser() === 'chrome') {
	    SlideUp00 = SlideUp;
	  }
	  return (
	    <SlideUp00 delay={450} fromX="-60px" fromY="60px">
	      <Base>
	        <MyLinkCard link="https://www.linkedin.com/in/Sondro" linkedin skewYanim>
	          <LinkedIn />
	        LinkedIn
	      </MyLinkCard>
	        <MyLinkCard link="https://www.github.com/Sondro" github skewYanim>
	          <GitHub />
	        GitHub
	      </MyLinkCard>
	        <MyLinkCard link="https://www.instagram.com/SondroIG" instagram skewYanim>
	          <Instagram />
	        Instagram
	      </MyLinkCard>
	      </Base>
	    </SlideUp00>
	  );
	};
	
	*/
	
	/*
	        <MyLinkCard link="https://www.behance.net/" behance>
	            <Behance />
	            Behance
	        </MyLinkCard>
	        <MyLinkCard link="https://youtu.be" youtube>
	            <YouTube />
	            Youtube
	        </MyLinkCard>
	
	    <MyLinkCard link="https://www.discordapp.com" discord>
	            <Discord />
	            Discord
	    </MyLinkCard>
	*/
	
	exports.default = ContactCards;
	module.exports = exports['default'];

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Header = __webpack_require__(13);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _website = __webpack_require__(8);
	
	var _website2 = _interopRequireDefault(_website);
	
	var _SlideUp = __webpack_require__(5);
	
	var _SlideUp2 = _interopRequireDefault(_SlideUp);
	
	var _Browser = __webpack_require__(6);
	
	var _Browser2 = _interopRequireDefault(_Browser);
	
	var _HandsHelping = __webpack_require__(42);
	
	var _HandsHelping2 = _interopRequireDefault(_HandsHelping);
	
	var _CenterWrap = __webpack_require__(21);
	
	var _CenterWrap2 = _interopRequireDefault(_CenterWrap);
	
	var _CenterDiv = __webpack_require__(15);
	
	var _CenterDiv2 = _interopRequireDefault(_CenterDiv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint max-len: 0 */
	
	var DivSVG = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1xnn6g90'
	})('svg{width:40rem;height:40rem;opacity:0.35;g{fill:', function (props) {
	  return props.theme.colors.cool.dark;
	}, ';}}position:absolute;top:-730px;left:100px;z-index:10;overflow:hidden;max-height:640px;@media (max-width:600px){max-height:560px;left:0px;top:-460px;svg{width:35rem;height:35rem;}');
	
	var SlideUp00 = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1xnn6g91'
	})();
	var ContactHeader = function ContactHeader() {
	  /*
	  if (Browser() === 'chrome') {
	    SlideUp00 = SlideUp;
	  }
	  */
	  SlideUp00 = _SlideUp2.default;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Help | ' + _website2.default.siteTitle }),
	    _react2.default.createElement(
	      _Header2.default,
	      { slim: true, title: '\xA0' + ':' + '\xA0' + ':' + '\xA0' + 'HELP' + '\xA0' + ':' + '\xA0' + ':' },
	      'Get In Touch / Get It Done'
	    ),
	    _react2.default.createElement(
	      SlideUp00,
	      { toY: '90px', fromX: '-90px' },
	      _react2.default.createElement(
	        _CenterWrap2.default,
	        null,
	        _react2.default.createElement(
	          _CenterDiv2.default,
	          null,
	          _react2.default.createElement(
	            DivSVG,
	            null,
	            _react2.default.createElement(_HandsHelping2.default, null)
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = ContactHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CenterDiv = __webpack_require__(15);
	
	var _CenterDiv2 = _interopRequireDefault(_CenterDiv);
	
	var _EmailFormDetails = __webpack_require__(71);
	
	var _EmailFormDetails2 = _interopRequireDefault(_EmailFormDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e85zkk60'
	})('z-index:22;position:relative;width:100%;max-width:1100px;margin-left:auto;margin-right:auto;padding-left:2rem;padding-right:2rem;');
	
	var EmailForm = /*#__PURE__*/(0, _reactEmotion2.default)('form', {
	  target: 'e85zkk61'
	})('text-align:center;svg{fill:white;}');
	var Shortcut = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e85zkk62'
	})('position:relative;z-index:0;top:-8rem;height:1px;@media (max-width:350px){top:-10rem;}');
	
	var ThanksDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e85zkk63'
	})('display:none;text-align:center;position:absolute;top:-52rem;z-index:12;width:100%;height:50rem;background-color:', function (props) {
	  return props.theme.set.light.trimOn;
	}, ';opacity:0;border-radius:', function (props) {
	  return props.theme.borderRadius.round;
	}, ';box-shadow:0px 6px 18px 0px rgba(0,0,0,1);transition:all 0.2s cubic-bezier(0.165,0.84,0.44,1);');
	
	var ThanksSpan = /*#__PURE__*/(0, _reactEmotion2.default)('span', {
	  target: 'e85zkk64'
	})('display:inline;position:relative;top:20rem;');
	
	var PostFrame = /*#__PURE__*/(0, _reactEmotion2.default)('iframe', {
	  target: 'e85zkk65'
	})('display:none;');
	
	var host = '';
	if (typeof window !== 'undefined') {
	  host = window.location.hostname;
	}
	
	if (host.match('localhost')) {
	  host = host + ':8000';
	}
	
	var frameCount = 0;
	var frameMax = 100;
	
	var EmailContact = function EmailContact() {
	  var checkIframe = function checkIframe() {
	    if (frameCount <= frameMax) {
	      if (!document.getElementById('postFrame').contentDocument) {
	        window.location.href = '//' + host + '/thanks/#email';
	      }
	
	      if (frameCount <= 10) {
	        setTimeout(checkIframe, 50);
	      } else {
	        setTimeout(checkIframe, 350);
	      }
	      //alert(frameCount);
	
	      frameCount++;
	    }
	  };
	
	  var handleSubmit = function handleSubmit(e) {
	
	    if (typeof document.getElementById('SpaceLabel').value !== 'undefined') {
	      e.preventDefault();
	      //alert(document.getElementById('SpaceLabel').value);
	      // alert("spam");
	    } else {
	        // if (agent !== "safari") {
	        //   document.getElementById("thanks").style.display = "inline";
	        //   document.getElementById("thanks").style.opacity = 0.95;
	        //   document.getElementById("EmailForm").style.opacity = 0;
	        // }
	      }
	
	    frameCount = 0;
	    frameMax = 100;
	
	    checkIframe();
	  };
	
	  return _react2.default.createElement(
	    ContactDiv,
	    null,
	    _react2.default.createElement(PostFrame, { id: 'postFrame', name: 'postFrame' }),
	    _react2.default.createElement(Shortcut, { name: 'email' }),
	    _react2.default.createElement(
	      EmailForm,
	      {
	        id: 'EmailForm',
	        'data-email': 'example@email.net',
	        method: 'POST',
	        action: 'https://fabform.io/f/AV3NTuU',
	        onSubmit: function onSubmit(e) {
	          return handleSubmit(e);
	        },
	        target: 'postFrame'
	      },
	      _react2.default.createElement('input', { type: 'hidden', value: host }),
	      _react2.default.createElement(_EmailFormDetails2.default, null)
	    ),
	    _react2.default.createElement(
	      _CenterDiv2.default,
	      null,
	      _react2.default.createElement(
	        ThanksDiv,
	        { id: 'thanks' },
	        _react2.default.createElement(
	          ThanksSpan,
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Message Sent'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Thank You!'
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = EmailContact;
	module.exports = exports['default'];

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(39);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Paperplane = __webpack_require__(102);
	
	var _Paperplane2 = _interopRequireDefault(_Paperplane);
	
	var _Browser = __webpack_require__(6);
	
	var _Browser2 = _interopRequireDefault(_Browser);
	
	var _hide = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyleInput = /*#__PURE__*/(0, _reactEmotion2.default)('input', {
	  target: 'e1cqj2j0'
	})('color:', function (props) {
	  return props.theme.set.light.p;
	}, ';font-size:22px;font-weight:bold;padding-bottom:10px;padding-left:20px;padding-right:20px;padding-top:1.5rem;border-radius:0.35rem;border:2px solid lightgray;width:100%;::placeholder{color:', function (props) {
	  return props.theme.set.light.placeholder;
	}, ';}background-color:', function (props) {
	  return props.theme.set.light.bgText;
	}, ';box-shadow:0px 6px 12px 0px rgba(0,0,0,0.75);transition:all 0.4s cubic-bezier(0.165,0.84,0.44,1);background-image:linear-gradient(\n    5deg,rgba(0,10,29,0.19) 0%,rgba(0,10,29,0) 35%,hsla(240,60%,97%,0.25) 100%\n  );&:hover{shadow:0px 6px 18px 0px rgba(0,0,0,0.7);background-color:', function (props) {
	  return props.theme.set.light.trimOn;
	}, ';}&:focus{shadow:0px 6px 22px 0px rgba(0,0,0,0.5);background-color:', function (props) {
	  return props.theme.set.light.pure;
	}, ';}');
	
	var EmailTab2 = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1cqj2j1'
	})('position:relative;display:inline-block;top:-47.5rem;padding-bottom:3rem;margin-left:5%;margin-right:95%;height:0.25rem;text-align:center;z-index:9;color:', function (props) {
	  return props.theme.set.light.p;
	}, ';transition:all 0.4s cubic-bezier(0.165,0.84,0.44,1);border-radius:0.35rem;border:2px solid lightgray;background-color:', function (props) {
	  return props.theme.set.light.trimOn;
	}, ';box-shadow:0px 6px 12px 0px rgba(0,0,0,0.25);/*\n  background-image:linear-gradient(\n    5deg,hsla(240,60%,97%,0.25) 0%,rgba(0,10,29,0) 75%,rgba(0,10,29,0.29) 100%\n  );*/\n  padding:1rem;@media (min-width:900px){top:-49.12rem;}@media (max-width:900px){top:-47.55rem;}@media (max-width:599px){top:-48.75rem;}@media (max-width:400px){top:-50.4rem;}');
	
	var TextAreaTab = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1cqj2j2'
	})('position:relative;display:inline-block;top:-38.25rem;padding-bottom:3rem;margin-left:5%;margin-right:95%;height:0.25rem;max-height:0.25rem;text-align:center;z-index:9;color:', function (props) {
	  return props.theme.set.light.p;
	}, ';transition:all 0.4s cubic-bezier(0.165,0.84,0.44,1);border-radius:0.35rem;border:2px solid lightgray;background-color:', function (props) {
	  return props.theme.set.light.trimOn;
	}, ';box-shadow:0px 6px 12px 0px rgba(0,0,0,0.25);/*\n  background-image:linear-gradient(\n    5deg,hsla(240,60%,97%,0.25) 0%,rgba(0,10,29,0) 75%,rgba(0,10,29,0.29) 100%\n  );*/\n  padding:1rem;@media (max-width:400px){top:-38.25rem;}');
	
	var TabText = /*#__PURE__*/(0, _reactEmotion2.default)('h1', {
	  target: 'e1cqj2j3'
	})('font-size:1.75rem;position:relative;display:inline-block;top:-0.8rem;padding-left:0rem;padding-bottom:0rem;left:-0.1rem;margin-left:0rem;z-index:9;text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThin;
	}, ';@media (max-width:450px){font-size:1.6rem;}');
	
	var StyledTextArea = /*#__PURE__*/(0, _reactEmotion2.default)('textarea', {
	  target: 'e1cqj2j4'
	})('color:', function (props) {
	  return props.theme.set.light.p;
	}, ';resize:none;font-size:22px;font-weight:bold;padding-bottom:10px;padding-left:20px;padding-right:20px;padding-top:1.65rem;border-radius:0.35rem;box-shadow:0px 6px 12px 0px rgba(0,0,0,0.75);border:2px solid lightgray;width:100%;min-height:30rem;::placeholder{color:', function (props) {
	  return props.theme.set.light.placeholder;
	}, ';}background-color:', function (props) {
	  return props.theme.set.light.bgText;
	}, ';transition:all 0.4s cubic-bezier(0.165,0.84,0.44,1);background-image:linear-gradient(\n    5deg,rgba(0,10,29,0.29) 0%,rgba(0,10,29,0) 75%,hsla(240,60%,97%,0.25) 100%\n  );&:hover{box-shadow:0px 6px 18px 0px rgba(0,0,0,0.7);background-color:', function (props) {
	  return props.theme.set.light.trimOn;
	}, ';}&:focus,&:active{', TextAreaTab, '{top:-39rem;}box-shadow:0px 6px 22px 0px rgba(0,0,0,0.5);background-color:', function (props) {
	  return props.theme.set.light.pure;
	}, ';}');
	
	var IconDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1cqj2j5'
	})('font-weight:900;font-family:\'\';font-size:22px;z-index:12;text-indent:-5px;border-radius:0.35rem;color:black;top:-43px;left:-5px;position:relative;width:60px;opacity:0;');
	
	var EmailnNameLabel = /*#__PURE__*/(0, _reactEmotion2.default)('label', {
	  target: 'e1cqj2j6'
	})('width:100%;@media (max-width:900px){width:100%;}');
	
	var SpaceLabel = /*#__PURE__*/(0, _reactEmotion2.default)('label', {
	  target: 'e1cqj2j7'
	})('width:2%;@media (max-width:900px){width:0px;}');
	
	var EmailDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1cqj2j8'
	})('positon:absolute;display:inline-block;transform:translateY(-0.25rem);padding-right:0rem;svg{g{stroke-width:3;}}');
	
	var agent = (0, _Browser2.default)();
	/*
	let SubjectY,
	  NameY,
	  EmailY = 0;
	*/
	// const hide = () => {
	//   if (typeof document.getElementById !== 'undefined') {
	//     if (agent === 'safari') {
	//     if (typeof document.getElementById('EmailTab') !== 'undefined') {
	//       document.getElementById('EmailTab').style.display = 'none';
	//     }
	//     document.getElementById('NameTab').style.display = 'none';
	//     document.getElementById('SubjectTab').style.display = 'none';
	//     }
	//   }
	// };
	
	var display = 'inline-block';
	
	var EmailFormDetails = function EmailFormDetails() {
	  if (agent === 'safari') {
	    // display = 'none';
	  }
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      EmailnNameLabel,
	      null,
	      _react2.default.createElement(StyleInput, { id: 'emailIn', type: 'email', name: 'email', maxlength: '512', placeholder: 'You@Email.com', required: true }),
	      _react2.default.createElement(
	        IconDiv,
	        { type: 'text', name: 'emailIcon' },
	        'A'
	      )
	    ),
	    _react2.default.createElement(SpaceLabel, { id: 'SpaceLabel' }),
	    _react2.default.createElement(StyledTextArea, {
	      id: 'message',
	      name: 'message',
	      type: 'text',
	      maxlength: '9999',
	      placeholder: 'Hi, I\'m looking for...',
	      required: true
	    }),
	    _react2.default.createElement(
	      _Button2.default,
	      { type: 'main' },
	      _react2.default.createElement(
	        EmailDiv,
	        null,
	        _react2.default.createElement(_Paperplane2.default, null)
	      ),
	      '\xA0' + ':' + '\xA0' + ':' + '\xA0' + 'EMAIL' + '\xA0' + ':' + '\xA0' + ':'
	    ),
	    _react2.default.createElement(
	      TextAreaTab,
	      { style: { display: '' + display } },
	      _react2.default.createElement(
	        TabText,
	        null,
	        'Message',
	        '\xA0',
	        ':'
	      )
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: _hide.hide },
	      _react2.default.createElement(
	        EmailTab2,
	        { id: 'EmailTab2', style: { display: '' + display } },
	        _react2.default.createElement(
	          TabText,
	          null,
	          'Email',
	          '\xA0',
	          ':'
	        )
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null)
	  );
	};
	
	exports.default = EmailFormDetails;
	// <span className={hide}>
	
	module.exports = exports['default'];

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HandsHelping = function HandsHelping() {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 644 524" },
	    _react2.default.createElement(
	      "g",
	      null,
	      _react2.default.createElement("path", { d: "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z" })
	    )
	  );
	};
	
	exports.default = HandsHelping;
	module.exports = exports["default"];

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Container = __webpack_require__(9);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SlideUp = __webpack_require__(5);
	
	var _SlideUp2 = _interopRequireDefault(_SlideUp);
	
	var _Browser = __webpack_require__(6);
	
	var _Browser2 = _interopRequireDefault(_Browser);
	
	var _EmailContact = __webpack_require__(130);
	
	var _EmailContact2 = _interopRequireDefault(_EmailContact);
	
	var _ContactCards = __webpack_require__(67);
	
	var _ContactCards2 = _interopRequireDefault(_ContactCards);
	
	var _ContactHeader = __webpack_require__(68);
	
	var _ContactHeader2 = _interopRequireDefault(_ContactHeader);
	
	var _FillBg = __webpack_require__(16);
	
	var _FillBg2 = _interopRequireDefault(_FillBg);
	
	var _LinePad = __webpack_require__(40);
	
	var _LinePad2 = _interopRequireDefault(_LinePad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e785jf80'
	})('margin-top:-1rem;margin-bottom:2rem;'); /* eslint max-len: 0 */
	
	var SlideUp00 = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e785jf81'
	})();
	
	var Contact = function Contact() {
	  if ((0, _Browser2.default)() === 'chrome') {
	    SlideUp00 = _SlideUp2.default;
	  }
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_ContactHeader2.default, null),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        _FillBg2.default,
	        null,
	        _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(_ContactCards2.default, null),
	          _react2.default.createElement(
	            SlideUp00,
	            { fromY: '0px', fromX: '64px', delay: 1400 },
	            _react2.default.createElement(_LinePad2.default, {
	              style: {
	                marginBottom: '4rem'
	              }
	            })
	          ),
	          _react2.default.createElement(
	            SlideUp00,
	            { delay: 340 },
	            _react2.default.createElement(_EmailContact2.default, null)
	          )
	        ),
	        _react2.default.createElement('br', null)
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-jsx-0857fec0d9dd7030fd74.js